/*
  Colour swatches on product cards.

  One delegated listener for every product grid on the site — Featured
  collection, Collection Cross Sell, Product recommendations, the collection
  grid and the Globo filter's client-side results. Delegation matters because
  recommendations and filtered results arrive over AJAX long after load.

  Behaviour:
  - hover does nothing, so the card never changes under the cursor
  - clicking a swatch swaps the card's main image and marks that swatch as the
    one currently on show
  - the swatch is a button sitting outside the card's link, so the image,
    title and price all stay a single link to the product
*/
(function () {
  var CARD = '[data-product-card]';
  var SWATCH = '.color-swatch--selectable';
  var IMAGE = '[data-product-card-image]';

  function select(swatch) {
    var card = swatch.closest(CARD);
    if (!card) return;

    var image = card.querySelector(IMAGE);
    var src = swatch.getAttribute('data-variant-image');

    if (image && src) {
      /* Lazy-loaded grids read `data-src`, so keep both in step whichever
         state lazysizes has left the image in. */
      image.setAttribute('src', src);
      if (image.hasAttribute('data-src')) image.setAttribute('data-src', src);
      image.removeAttribute('srcset');
      if (image.hasAttribute('data-srcset')) image.removeAttribute('data-srcset');

      /* Cards with a hover image hold the product's second media, which
         belongs to whichever colour the card opened on. Once a swatch has
         moved the card to another colour that image is the wrong one, so
         mark the card and let the grid's CSS drop it. */
      card.setAttribute('data-card-image-swapped', '');
    }

    card.querySelectorAll(SWATCH).forEach(function (other) {
      var selected = other === swatch;
      other.classList.toggle('is-selected', selected);
      other.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(SWATCH);
    if (!swatch) return;
    event.preventDefault();
    select(swatch);
  });
})();
